import type { Invoice } from '@/types/invoice'
import { DEADLINE_TONE, formatCurrency, formatDate, getPaymentDeadline } from './invoiceUtils'

/**
 * Zahlungsfrist in der Rechnungsliste (#125/#126).
 *
 * Solange Skonto zu holen ist, steht die SKONTOFRIST oben — das ist der Termin,
 * an dem gehandelt werden muss — und darunter klein das endgueltige Zahlungsziel.
 * Vorher stand hier nur die Faelligkeit, das Skonto war ein Dollar-Icon mit
 * Tooltip, und weil die Extraktion die Felder fast nie fuellte, zeigte die Spalte
 * bei nahezu jeder Rechnung "Sofort fällig".
 *
 * Ampel bei laufender Skontofrist: <= 7 Tage rot, <= 14 gelb, sonst gruen.
 */
export default function DueDateCell({ invoice }: { invoice: Invoice }) {
  const d = getPaymentDeadline(invoice)
  const tone = d.tone ? DEADLINE_TONE[d.tone] : null

  return (
    <div className="flex items-start gap-1.5 leading-tight">
      {tone && <span className={`mt-1.5 h-2 w-2 flex-shrink-0 rounded-full ${tone.dot}`} />}
      <div className="min-w-0">
        <div className={`flex flex-wrap items-baseline gap-x-1.5 ${tone?.text || 'text-gray-600'}`}>
          <span className="tabular-nums">
            {d.actionDate ? formatDate(d.actionDate) : (invoice.type === 'reminder' ? '-' : 'Sofort fällig')}
          </span>
          {d.skontoActive && (
            <span className="text-xs font-semibold">
              {d.skontoPercent}%
              {/* Der Betrag steht nur auf rund zwei Dritteln der Belege — er wird
                  bewusst NICHT aus Brutto × Satz gerechnet, weil Fracht und
                  Dienstleistungen oft nicht skontierfähig sind. */}
              {d.skontoAmount != null && ` · ${formatCurrency(d.skontoAmount)}`}
            </span>
          )}
        </div>
        {d.skontoActive && d.dueDate && (
          <div className="text-[11px] text-gray-400 tabular-nums">
            (netto {formatDate(d.dueDate)})
          </div>
        )}
      </div>
    </div>
  )
}
